import { findRecursive } from '@/mm/utils.js'

export function washData_relatedCarouselFaq(walkedNode) {
  const ProNode = findRecursive(
    walkedNode.list,
    (item) => item.componentName === 'text_title',
    'list'
  )
  if (walkedNode._type === 'related_carousel_faq1') {
    if (ProNode) {
      if (!ProNode.actions.find((item) => item === 'edit')) {
        ProNode.actions.unshift('edit')
      } else if (!ProNode.actions.find((item) => item === 'translate')) {
        ProNode.actions.push('translate')
      }
    }
  } else if (walkedNode._type === 'related_carousel_faq2') {
    if (ProNode) {
      if (!ProNode.actions.find((item) => item === 'edit')) {
        ProNode.actions.unshift('edit')
      } else if (!ProNode.actions.find((item) => item === 'translate')) {
        ProNode.actions.push('translate')
      }
    }
  } else if (walkedNode._type === 'related_carousel_faq4') {
    if (ProNode) {
      if (!ProNode.actions.find((item) => item === 'edit')) {
        ProNode.actions.unshift('edit')
      } else if (!ProNode.actions.find((item) => item === 'translate')) {
        ProNode.actions.push('translate')
      }
    }
  }
}
